import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import error from "../../utils/error";
import BackupHistoryServices, { IBackupHistoryInfo } from "../../services/backupHistoryApi";

interface IBackupHistoryPageState {
  backupHistoryList: {
    isLoading: boolean,
    status: string,
    data: IBackupHistoryInfo[],
    error?: string
  },
  backupJobHistoryList: {
    isLoading: boolean,
    status: string,
    data: IBackupHistoryInfo[],
    error?: string
  },
}

const initialBackupState: IBackupHistoryPageState = {
  backupHistoryList: {
    isLoading: false,
    status: "",
    data: [],
    error: undefined
  },
  backupJobHistoryList: {
    isLoading: false,
    status: "",
    data: [],
    error: undefined
  }
};

export const getBackupHistoryList = createAsyncThunk(
  "backup/getBackupHistory",
  async () => {
    try {
      return BackupHistoryServices.getBackupHistory();
    } catch (error_) {
      return error_;
    }
  }
);

export const getBackupJobHistoryByHistoryId = createAsyncThunk(
  "backup/getBackupJobHistoryByHistoryId",
  async (backupHistoryId: string) => {
    try {
      return BackupHistoryServices.getBackupJobHistoryByHistoryId(backupHistoryId);
    } catch (error_) {
      return error_;
    }
  }
);

const backupHistorySlice = createSlice({
  name: "backupHistory",
  initialState: initialBackupState,
  reducers: {},
  extraReducers(builder): void {
    // Get backup history
    builder.addCase(getBackupHistoryList.pending, (state) => {
      state.backupHistoryList.isLoading = true;
    });
    builder.addCase(getBackupHistoryList.fulfilled, (state, action) => {
      state.backupHistoryList.isLoading = false;
      state.backupHistoryList.data = action.payload;
    });
    builder.addCase(getBackupHistoryList.rejected, (state, action) => {
      state.backupHistoryList.isLoading = false;
      state.backupHistoryList.error = error(action.payload);
    });

    // Get backup job history
    builder.addCase(getBackupJobHistoryByHistoryId.pending, (state) => {
      state.backupJobHistoryList.isLoading = true;
    });
    builder.addCase(getBackupJobHistoryByHistoryId.fulfilled, (state, action) => {
      state.backupJobHistoryList.isLoading = false;
      state.backupJobHistoryList.data = action.payload;
    });
    builder.addCase(getBackupJobHistoryByHistoryId.rejected, (state, action) => {
      state.backupJobHistoryList.isLoading = false;
      state.backupJobHistoryList.error = error(action.payload);
    });
  },
});

export default backupHistorySlice.reducer;
